// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const nailKeg = defineModel({
  id: "nail-keg",
  batchId: "future",
  name: "Nail keg",
  tags: ["scenery","nail","keg","low-poly","age-of-mcp","future"],
  summary: "A keg of nails — the fastener every timber structure needs.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.34,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.172, 0.172, 0.3, 9), color: "#7a5126", position: [0, 0.15, 0] },
      { geometry: new THREE.CylinderGeometry(0.176, 0.176, 0.025, 9), color: "#4f3a22", position: [0, 0.084, 0] },
      { geometry: new THREE.CylinderGeometry(0.176, 0.176, 0.025, 9), color: "#4f3a22", position: [0, 0.234, 0] },
      { geometry: new THREE.ConeGeometry(0.156, 0.12, 9), color: "#6f747a", position: [0, 0.34, 0] },
      { geometry: new THREE.ConeGeometry(0.01, 0.1, 4), color: "#6f747a", position: [0.07, 0.38, 0], rotation: [0.4, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.01, 0.1, 4), color: "#878d93", position: [0.035, 0.38, 0.060622], rotation: [0.2, 0, -0.34641] },
      { geometry: new THREE.ConeGeometry(0.01, 0.1, 4), color: "#6f747a", position: [-0.035, 0.38, 0.060622], rotation: [-0.2, 0, -0.34641] },
      { geometry: new THREE.ConeGeometry(0.01, 0.1, 4), color: "#878d93", position: [-0.07, 0.38, 0], rotation: [-0.4, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.01, 0.1, 4), color: "#6f747a", position: [-0.035, 0.38, -0.060622], rotation: [-0.2, 0, 0.34641] },
      { geometry: new THREE.ConeGeometry(0.01, 0.1, 4), color: "#878d93", position: [0.035, 0.38, -0.060622], rotation: [0.2, 0, 0.34641] },
    ],
  animations: [],
});
